// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import VueFullPage from 'vue-fullpage.js'
import BootstrapVue from 'bootstrap-vue'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/custom.scss'
import VueAnalytics from 'vue-analytics'

Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VueFullPage)
Vue.use(VueAnalytics, {
  id: 'UA-149006259-1',
  autoTracking: {
    screenview: true,
    untracked: false
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js